import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import _ from 'lodash';
import React, { useCallback } from 'react';
import { Link } from '@jutro/router';
import messages from '../../Claims.messages';
import styles from '../../Claims.module.scss';
import ClaimServicesPrimaryContactPopupMetaData from './ContactDetailsPopup.metadata.json5';


function ContactLinkComponent(props) {
    const { showAlert } = useModal();

    const translator = useTranslator();
    const contactDetails = _.get(props, 'contactDetails');

    const getPrimaryMobilePhoneNumber = useCallback(
        item => {
            if (item.cellNumber) {
                const formattedPhoneNumber = item.cellNumber.replace( // DE17331
                    /(\d{3})(\d{3})(\d{4})/,
                    '$1-$2-$3'
                );

                if (item.primaryPhoneType === 'mobile') {
                    return `${formattedPhoneNumber}(${translator(
                        messages.modalPrimary
                    )})`;
                }

                return formattedPhoneNumber;
            }

            return null;
        },
        [translator]
    );

    const getPrimaryWorkPhoneNumber = useCallback(
        item => {
            if (item.workNumber) {
                const formattedPhoneNumber = item.workNumber.replace(  // DE17331
                    /(\d{3})(\d{3})(\d{4})/,
                    '$1-$2-$3'
                );

                if (item.primaryPhoneType === 'work') {
                    return `${formattedPhoneNumber}(${translator(
                        messages.modalPrimary
                    )})`;
                }

                return formattedPhoneNumber;
            }

            return null;
        },
        [translator]
    );

    const getPrimaryHomePhoneNumber = useCallback(
        item => {
            if (item.homeNumber) {
                const formattedPhoneNumber = item.homeNumber.replace(  // DE17331
                    /(\d{3})(\d{3})(\d{4})/,
                    '$1-$2-$3'
                );

                if (item.primaryPhoneType === 'home') {
                    return `${formattedPhoneNumber}(${translator(
                        messages.modalPrimary
                    )})`;
                }

                return formattedPhoneNumber;
            }

            return null;
        },
        [translator]
    );

    const getPrimaryContactPopupModalContent = useCallback(item => {
        const isFieldVisible = item.contactType !== 'Company';
        const claimExaminerRole = ['Sr. Commercial Claims Examiner', 'Claims Examiner'].includes(contactDetails.role) || (contactDetails.role.indexOf('Claims Examiner') !== -1);
        const independentAdjuster = contactDetails.role === 'Field Adjuster'
        const overrides = {
            primaryContactHomeNumber: {
                value: getPrimaryHomePhoneNumber(item),
                visible: isFieldVisible && !claimExaminerRole && !independentAdjuster, // Hide if claimExaminerRole or independentAdjuster is true
            },
            primaryContactWorkNumber: {
                value: getPrimaryWorkPhoneNumber(item),
                visible: isFieldVisible || claimExaminerRole || independentAdjuster, // Visible for both claimExaminerRole and independentAdjuster
            },
            primaryContactMobileNumber: {
                value: getPrimaryMobilePhoneNumber(item),
                visible: isFieldVisible && !claimExaminerRole && !independentAdjuster, // Hide if claimExaminerRole or independentAdjuster is true
            },
            primaryContactAddress: {
                visible: !independentAdjuster || claimExaminerRole, // Visible if either claimExaminerRole or not independentAdjuster
            },
            primaryContactEmail: {
                visible: !independentAdjuster, // Visible if claimExaminerRole is true
            }
        };
        
        if (claimExaminerRole) {
            // If claimExaminerRole is true, only address, work phone, and email are visible
            overrides.primaryContactHomeNumber.visible = false;
            overrides.primaryContactMobileNumber.visible = false;
            overrides.primaryContactEmail.visible = true;
        }
        
        if (independentAdjuster) {
            // If independentAdjuster is true, only name and work phone number should be visible
            overrides.primaryContactHomeNumber.visible = false;
            overrides.primaryContactMobileNumber.visible = false;
            overrides.primaryContactAddress.visible = false;
            overrides.primaryContactEmail.visible = false;
        }

        const readValue = (id, path) => readViewModelValue(
                ClaimServicesPrimaryContactPopupMetaData.pageContent,
                item,
                id,
                path,
                overrides
            );

        const resolvers = {
            resolveValue: readValue,
            resolveClassNameMap: styles,
        };

        return (
            <MetadataContent
                uiProps={ClaimServicesPrimaryContactPopupMetaData.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
    }, [contactDetails?.role, getPrimaryHomePhoneNumber, getPrimaryMobilePhoneNumber, getPrimaryWorkPhoneNumber]);

    const openContactPopup = useCallback(
        (event, item) => {
            event.preventDefault();

            const name = _.get(item, 'name', '');
            const renderServiceVendorContent =
                getPrimaryContactPopupModalContent(item);

            showAlert({
                title: name,
                message: renderServiceVendorContent,
                status: 'info',
                icon: 'mi-error-outline',
            }).catch(_.noop);
        },
        [getPrimaryContactPopupModalContent, showAlert]
    );

    return (
        <Link
            className={styles.contactDetailsLink}
            onClick={event => openContactPopup(event, contactDetails)}
            href="/"
        >
            {contactDetails.name}
        </Link>
    );
}

export default ContactLinkComponent;
